export const MIXED_COLOR_VALUE = 'mixed';
